module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_7042.08e26939.png";